export default "__VITE_ASSET__CjGD2zZ2__"